<template>
  <div class="Container">
    <div class="searchBtn" v-if="showFunBtn === true">
      <el-button  v-for="(item, index) in operate" :key="index" :icon="item.icon" :loading="item.loadingBtn" :type="item.type" :disabled="item.disabled ? item.disabled : false" @click="item.handleClick" class="more_thanfour_btn">{{ item.name }}
      </el-button>
    </div>
    <div class="content-wrap">
      <div v-for="(col, colI) in contentConfig" :key="colI" class="item-wrap">
        <div v-if="(!col.show && col.show !== false) || col.show === true ? true : false">
          <!-- 默认标题 -->
          <div v-if="col.title && !col.cursomTitle" class="item-wrap-title">{{ col.title }}</div>
          <!-- 自定义标题 -->
          <div v-if="col.cursomTitle">
            <slot :name="col.name" :slotData="col" />
          </div>
          <!-- 默认表单 -->
          <el-form v-if="col.form" ref="form" v-loading="col.loading" :model="col.form" :class="{'read-only-wrap' : col.readOnly, 'item-form': true}" :disabled="col.readOnly" label-position="left" :label-width="col.labelWidth" :rules="col.rules" size="small">
            <el-row class="item-row-wrap" :gutter="120">
              <template v-for="(item,index) in col.formItemList">
                <el-col :key="index" :xs="24" :sm="24" :md="item.md? item.md : 24" :lg="item.lg ? item.lg : 24" :xl="item.xl ? item.xl : 24">
                  <el-form-item v-if="item.show || item.show === false ? item.show : true " :style="{width: item.width}" :label="item.label" :prop="item.prop">
                    <!-- 密码 -->
                    <el-input v-if="item.type === 'password'" v-model="col.form[item.prop]" type="password" :disabled="item.disabled ? item.disabled : false" :placeholder="item.placeholder" />
                    <!-- input输入框 无需触发其他事件 -->
                    <el-input v-if="item.type === 'input'" v-model="col.form[item.prop]" :disabled="item.disabled ? item.disabled : false" :placeholder="item.placeholder" @change="inputChange(item)" />
                    <el-input v-if="item.type === 'inputHasClick'" v-model="col.form[item.prop]" :disabled="item.disabled ? item.disabled : false" :placeholder="item.placeholder" @click.native="clickInput(item)" />
                    <!-- textarea文本框 -->
                    <el-input v-if="item.type === 'textarea'" v-model="col.form[item.prop]" type="textarea" :disabled="item.disabled ? item.disabled : false" :placeholder="item.placeholder" />
                    <!-- 下拉框 -->
                    <el-select v-if="item.type==='select'" v-model="col.form[item.prop]" :placeholder="item.placeholder" :disabled="item.disabled ? item.disabled : false" clearable :multiple="item.multiple ? item.multiple : false" @change="selectChange(item)">
                      <el-option v-for="(optItem, opti) in item.list" :key="opti" :label="optItem.label" :value="optItem.value" :disabled="optItem.disabled ? optItem.disabled : false" />
                    </el-select>
                    <!-- 下拉框可分组 -->
                    <el-select v-if="item.type==='selectgroup'" v-model="col.form[item.prop]" :placeholder="item.placeholder" :disabled="item.disabled ? item.disabled : false" clearable :multiple="item.multiple ? item.multiple : false">
                      <el-option-group v-for="group in item.optList" :key="group.label" :label="group.label">
                        <el-option v-for="groupItem in group.options" :key="groupItem.value" :label="groupItem.label" :value="groupItem.value" />
                      </el-option-group>
                    </el-select>
                    <!-- Cascader 级联选择器 -->
                    <el-cascader v-if="item.type==='cascader' && (item.show === undefined ? true : item.show) " v-model="col.form[item.prop]" :placeholder="item.placeholder" :options="item.list" :disabled="item.disabled ? item.disabled : false" clearable :props="item.props" @change="cascaderChange(col.form[item.prop])" />
                    <!-- 日期选择 -->
                    <el-date-picker v-if="item.type==='date'" v-model="col.form[item.prop]" :value-format="item.dateFormate ? item.dateFormate : 'yyyy-MM-dd'" :type="item.type" :disabled="item.disabled ? item.disabled : false" :placeholder="item.placeholder" style="width:100%;" />
                    <el-date-picker v-if="item.type==='datetime'" v-model="col.form[item.prop]" :value-format="item.dateFormate" :type="item.type" :disabled="item.disabled ? item.disabled : false" :placeholder="item.label" style="width:100%;" />
                    <template v-if="item.type === 'custom'">
                      <slot :name="item.name" :slotData="item" />
                    </template>
                    <!-- 开关 -->
                    <el-switch v-if="item.type==='switch'" v-model="col.form[item.prop]" active-color="#13ce66" inactive-color="rgb(215, 215, 215)" :disabled="item.disabled ? item.disabled : false" :active-text="item.activeText" :inactive-text="item.inActiveText" @change="item.methods" />
                    <!-- 单选 -->
                    <el-radio-group v-if="item.type==='radio'" v-model="col.form[item.prop]" :disabled="item.disabled ? item.disabled : false" @change="item.methods">
                      <el-radio v-for="radioItem in item.list" :key="radioItem.value" :label="radioItem.value">{{ radioItem.label }}</el-radio>
                    </el-radio-group>
                    <!-- 省市县地区四级联 -->
                    <el-cascader size="small" v-if="item.type === 'area' && (item.lazyEchoed || item.lazyEchoed == false ? item.lazyEchoed : true )" v-model="col.form[item.prop]" :props="item.props" :disabled="item.disabled ? item.disabled : false"></el-cascader>
                     <!-- 级联动态加载 -->
                    <el-cascader v-if="item.type === 'lazyCascader' && (item.lazyEchoed || item.lazyEchoed == false ? item.lazyEchoed : true )"  clearable size="small" v-model="col.form[item.prop]" :disabled="item.disabled ? item.disabled : false" :options="item.options" :props="item.props" :placeholder="item.placeholder" :show-all-levels="item.showAllLevels || item.showAllLevels == false ? item.showAllLevels : true"></el-cascader>
                    <!-- 等级 -->
                    <el-rate class="item-form-rate" v-if="item.type==='rate'" v-model="col.form[item.prop]" :disabled="item.disabled ? item.disabled : false"></el-rate>
                    <!-- 组织  安翼保控件 --> 
                    <!-- IsNeedRight :IsNeedRight="IsNeedRight"// 0 不走权限 1 走权限 默认是1 -->
                    <!-- :multiple="true"//是否多选 -->
                    <!-- :DataResultFormat="DataResultFormat"////数据返回格式0 机构+组织,1 组织,2代表原来初始默认 -->
                    <!-- :CompanyOfType="CompanyOfType"//默认0 1 客户 2 供应商 3本机构 4 本机构+客户 5.取除了厂商以外的数据 先取这些，后期需要再扩展 -->
                    <!-- :isSelCompany="isSelCompany"//默认true 机构是否可选 -->
                    <ayb-select-institution v-if="item.type === 'organization'" :isSelCompany="(!item.isSelCompany && item.isSelCompany !== false) ? true : false" :IsNeedRight="item.IsNeedRight ? item.IsNeedRight : 0 " :multiple="item.multiple" v-model="col.form[item.prop]" @getValue="item.getValue" />
                    <!-- 只选择机构  安翼保控件 -->
                    <ayb-selectInstitution-dept v-if="item.type === 'onlyOrg'" :multiple="item.multiple" v-model="col.form[item.prop]" @getValue="item.getValue" />
                    <!-- 岗位 安翼保控件 -->
                    <ayb-select-post v-if="item.type === 'post'" :multiple="item.multiple" v-model="col.form[item.prop]" @getValue="item.getValue" />
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
          </el-form>
          <!-- 自定义内容 -->
          <div v-if="!col.form && !col.cursomTitle" v-loading="col.loading">
            <template>
              <slot :name="col.name" :slotData="col" />
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-wrap">
      <slot name="btn" />
    </div>
  </div>

</template>
<script>
// import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  name: 'FormDialog',
  // components: { VueUeditorWrap },
  props: {
    // 是否现在右侧关闭按钮
    showBack: {
      type: Boolean,
      default() {
        return true
      }
    },
    showFunBtn: {
      type: Boolean,
      default() {
        return true
      }
    },
    // 添加或编辑或查看配置项
    contentConfig: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 按钮
    operate: {
      type: Array,
      default: () => {
        return []
      }
    },
    slotData: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      myConfig: {
        serverUrl: `/stage-api/web-resource/open/ueditor/upload`, // 上传功能的后端服务器接口地址
        UEDITOR_HOME_URL: '/UEditor/', // 你的UEditor资源存放的路径,相对于打包后的index.html
        autoHeightEnabled: true, // 编辑器是否自动被内容撑高
        autoFloatEnabled: false, // 工具栏是否可以浮动
        initialFrameHeight: 400, // 初始容器高度
        initialFrameWidth: '100%', // 初始容器高度
        enableAutoSave: true, // 关闭自动保存
        imageUrlPrefix: '/stage-api'
      }
    }
  },
  computed: {},
  mounted() {
  },
  methods: {
    goBack() {
      this.$emit('goBack')
    },
    selectChange(item) {
      this.$emit('selectChange', item)
    },
    cascaderChange(item) {
      this.$emit('cascaderChange', item)
    },
    clickInput(item) {},
    inputChange(item) {
      this.$emit('inputChange', item)
    }
  }
}
</script>
<style lang="scss" scoped>
    .item-row-wrap{
        display: flex;
        flex-wrap: wrap;
    }
  /deep/.el-form-item.el-form-item--small {
    display: flex;
    align-items: center;
    .el-form-item__content {
      margin-left: 0px !important;
      flex-grow: 1;
      .el-cascader {
        width: 100%;
      }
    }
  }
  .Container {
    background-color: #e9eef1;
    // padding-top: 10px;
  }
  .btn-wrap {
    margin-bottom: 20px;
  }
  .content-wrap {
    padding: 10px 20px;
    background-color: #fff;
    overflow-x: hidden;
    overflow-y: auto;
    position: fixed;
    height: calc(100% - 100px);
  }
  .searchBtn {
    padding: 10px 20px;
    margin-bottom: 10px;
    background-color: #fff;
    position: sticky;
    top: 0;
    z-index: 999;
    box-shadow: 0 1px 5px 1px rgba($color: #000000, $alpha: 0.1);
    width: 100%;
    .el-button + .el-button {
      margin-left: 10px;
    }
  }
  .el-form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
  }
  .formListLess {
    width: 100%;
  }
  .formListMore {
    width: 45%;
  }
  /deep/.el-button-group {
    .el-button + .el-button {
      margin-left: 20px;
    }
  }
  .el-select {
    width: 100%;
  }
  .header {
    text-align: right;
    padding: 10px;
  }
  .item-wrap {
    width: 100%;
    .item-wrap-title {
      color: #23ad9e;
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 30px;
      margin-top: 12px;
    }
    .item-form {
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  .row-flex {
    display: flex;
    flex-wrap: wrap;
  }
</style>
<style>
  .dialog-self .el-dialog__body {
    padding: 20px 40px 30px;
  }
  .formWrapLess .el-dialog {
    width: 35%;
  }
  .formWrapMore .el-dialog {
    width: 60%;
  }
</style>
